export default __webpack_public_path__ + "static/media/UNDP_logo.811464c8.png";